import React from 'react';

const ConstructionPage = ({ setPage }) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-gray-900 to-black text-white p-4">
      <div className="bg-gray-800 bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-3xl p-8 md:p-12 shadow-2xl border border-gray-700 max-w-2xl text-center transform transition-all duration-500 hover:scale-105">
        <h1 className="text-4xl md:text-6xl font-extrabold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-600 animate-pulse">
          ¡Sitio en Construcción!
        </h1>
        <p className="text-lg md:text-xl mb-8 text-gray-300 leading-relaxed">
          Estamos trabajando duro para traerte algo increíble. ¡Paciencia, que lo bueno se hace esperar!
        </p>
        <div className="space-y-4">
          <p className="text-md md:text-lg text-gray-400">
            Mientras tanto, puedes comunicarte con nosotros:
          </p>
          <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-6">
            <a
              href="tel:+51928220222"
              className="flex items-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 transform hover:scale-110 shadow-lg"
            >
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.773-1.548a1 1 0 011.06-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"></path>
              </svg>
              +51 928 220 222
            </a>
            <a
              href="mailto:ventas@ferrtechsac.com"
              className="flex items-center bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 transform hover:scale-110 shadow-lg"
            >
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
              </svg>
              ventas@ferrtechsac.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConstructionPage;